import SetActiveTransactionModal from './SetActiveTransactionModal';

export default SetActiveTransactionModal;
